import styled from 'styled-components';

const Style = styled.div``;

export default Style;
